import all from './all';
import items from './items';
import store from './store';
import show from './show';
import update from './update';
import destroy from './destroy';
import storeRules from './storeRules';
import showRules from './showRules';

export default {
  all,
  items,
  store,
  show,
  update,
  destroy,
  storeRules,
  showRules,
};



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/index.js